/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GrantServiceAccessThroughOnboarding$Params {

/**
 * The user uid
 */
  userUid: string;

/**
 * The subscription uid
 */
  serviceUid: string;
}

export function grantServiceAccessThroughOnboarding(http: HttpClient, rootUrl: string, params: GrantServiceAccessThroughOnboarding$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, grantServiceAccessThroughOnboarding.PATH, 'post');
  if (params) {
    rb.path('userUid', params.userUid, {});
    rb.path('serviceUid', params.serviceUid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

grantServiceAccessThroughOnboarding.PATH = '/custom/onboarding/user/{userUid}/service/{serviceUid}';
